import { reaction, when } from 'mobx';
import { useEffect } from 'react';

const useMobileNavigation = ({
  navigation,
  mobileNavigationRef,
  onTabChange,
  onClose,
}) => {
  useEffect(() => {
    const onTabChangeDisposer = reaction(
      () => navigation.activeTab,
      () => {
        onTabChange && onTabChange(mobileNavigationRef);
      }
    );

    const onOpenDisposer = when(
      () => navigation.isOpen,
      () => {
        onTabChange && onTabChange(mobileNavigationRef);
      }
    );

    const onCloseDisposer = when(
      () => !navigation.isOpen,
      () => {
        onClose && onClose(mobileNavigationRef);
      }
    );

    // Cleanup reaction when the component unmounts
    return () => {
      onTabChangeDisposer();
      onOpenDisposer();
      onCloseDisposer();
    };
  }, []);
};

export default useMobileNavigation;
